import {
  OperationVariables,
  UseFragmentOptions,
  useFragment,
} from '@apollo/client';

export const useCompleteFragment = <TData = any, TVars = OperationVariables>(
  options: UseFragmentOptions<TData, TVars>
) => {
  const { data, complete } = useFragment(options);
  if (!complete) {
    return null;
  }
  return data;
};
